
export enum TableCellType {
  TEXT = "text",
  NUMBER = "number",
  DATE = "date",
  ICONS = "icons",
  ACTIONS = "actions",
  STATUS = "status",
  WORKFLOW_RUN_STATUS = "WorkflowRunStatus",
  LINK_BUTTON = "linkButton",
  ACTION_BUTTON = "actionButton"
}
